import { render } from "./ProjectsActiveTable.vue?vue&type=template&id=7a314f80"
import script from "./ProjectsActiveTable.vue?vue&type=script&lang=js"
export * from "./ProjectsActiveTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__